module.exports = __webpack_public_path__ + "img/sld_scb_30_t1_b1_green.43ad99d2.svg";